import type { SocialPostSceneBlockV1 } from "@runcheetah/shared";

export function getCarouselArtboardSelectionBlockId(input: {
  currentBlockId: string | null;
  slideBlocks: readonly SocialPostSceneBlockV1[];
}): string | null {
  if (
    input.currentBlockId &&
    input.slideBlocks.some((block) => block.id === input.currentBlockId)
  ) {
    return input.currentBlockId;
  }

  return input.slideBlocks[0]?.id ?? null;
}
